import styled from "styled-components";

export const texto =
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam et nunc ut lacus porta ultrices quis in libero. Fusce non lectus a nibh egestas sodales sed vitae diam. Cras non sapien facilisis, lobortis dui at, vestibulum tortor.";

export const Card = styled.section`
  display: flex;
  flex-direction: column;
  width: 20%;
  height: 100%;
  justify-items: center;
  align-items: center;
  text-align: center;
  padding-left: 20px;
  padding-right: 20px;
  justify-content: center;
  color: #373737;

  h2 {
    font-size: 20px;
    margin-bottom: 15px;

    color: #194153;
  }

  span {
    margin-top: -10px;
    font-style: italic;
    font-size: 15px;
    text-transform: uppercase;
  }
  p {
    margin-top: 10px;
    font-size: 14px;
  }
  svg {
    width: 50px;
    height: 50px;
  }
`;

export const Container1 = styled.div`
  padding-left: ${props => props.paddingLeft};
  display: flex;
  padding-top: 3%;
  width: 100%;
  height: 65%;
  background: ${props => props.background};
  justify-content: space-between;
`;

export const ContainerHeader = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-items: center;
  align-items: center;
`;

export const ApresentacaoImagem = styled.div`
  opacity: 0;
  display: flex;
  width: 40%;
  height: 100%;
  margin-bottom: 10px;
  justify-items: center;
  align-items: center;
`;

export const ContainerDefault = styled.section`
  display: flex;
  flex-direction: column;
  width: 40%;
  height: 100%;
  justify-items: center;
  justify-content: center;
  h2 {
    font-size: 40px;
    margin: 0;
    color: white;
  }

  p {
    max-width: 80%;
    font-size: 19px;
    color: white;
  }

  img {
    margin-right: 20px;
  }
`;

export const ContainerEditalTexto = styled(ContainerDefault)`
  animation: ${props =>
    props.scroll && "fade-in 3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both"};
  opacity: 0;

  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const Container1Texto = styled.article`
  display: flex;
  padding-left: ${props => props.paddingLeft};
  flex-direction: column;
  width: 40%;
  height: 100%;
  justify-items: center;
  justify-content: center;

  h2 {
    font-size: 40px;
    margin: 0;
    color: white;
  }

  p {
    max-width: 80%;
    font-size: 19px;
    color: white;
  }

  img {
    margin-right: 20px;
  }
`;

export const Container2 = styled.div`
  display: flex;
  width: 95%;
  height: 35%;
  justify-items: center;
  align-content: center;
  align-items: center;
  background: white;
  text-align: center;
  justify-content: space-around;
`;
export const Triangulo = styled.div`
  position: relative;
  top: -15px;
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 15px solid white;
`;
